import { msalInstance } from '../AuthProvider';

/**
 * Get an access token for API requests
 * Returns null if not authenticated
 */
export async function getAccessToken(): Promise<string | null> {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ['api://3ece6ead-8344-447d-b419-450b27931f5c/access_as_user'],
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    console.error('Failed to acquire token:', error);
    // If silent token acquisition fails, try interactive login
    try {
      const response = await msalInstance.acquireTokenPopup({
        scopes: ['api://3ece6ead-8344-447d-b419-450b27931f5c/access_as_user'],
      });
      return response.accessToken;
    } catch (popupError) {
      console.error('Failed to acquire token via popup:', popupError);
      return null;
    }
  }
}

/**
 * Make an authenticated API request
 * Automatically adds the Authorization header with the access token
 */
export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = await getAccessToken();

  if (!token) {
    throw new Error('Not authenticated. Please sign in.');
  }

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  });
}
